// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vA92z{display:flex;flex-direction:column;gap:16px;padding:24px;max-width:720px;margin:0 auto;width:100%}.OmH3i{display:flex;flex-direction:column;gap:4px}.Fia6R{width:752px}.ckKz8{width:100%}.blvgL{gap:16px}.AExvy{display:flex;flex-direction:column;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `vA92z`,
	"field": `OmH3i`,
	"card": `Fia6R`,
	"cardMobile": `ckKz8`,
	"cardFields": `blvgL`,
	"paymentTerms": `AExvy`
};
export default ___CSS_LOADER_EXPORT___;
